import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b2abc65a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-btn" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "dropdown-toggle btn",
    type: "button"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "glyphicon glyphicon-calendar" })
  ])
], -1))

import { DatePicker, Dropdown } from "uiv";


export default /*#__PURE__*/_defineComponent({
  __name: 'jyre-date-picker',
  props: /*#__PURE__*/_mergeModels({
    limitFrom: { default: null }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const date = _useModel(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dropdown), { class: "form-group" }, {
    dropdown: _withCtx(() => [
      _createElementVNode("li", null, [
        _createVNode(_unref(DatePicker), {
          modelValue: date.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((date).value = $event)),
          "clear-btn": false,
          "limit-from": _ctx.limitFrom
        }, null, 8, ["modelValue", "limit-from"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
          class: "form-control",
          type: "text",
          "aria-label": "selected date"
        }, null, 512), [
          [_vModelText, date.value]
        ]),
        _hoisted_2
      ])
    ]),
    _: 1
  }))
}
}

})